module.exports = __webpack_public_path__ + "static/img/tu1.020880d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu1.png
// module id = t0bg
// module chunks = 1